import { Alert, AlertIcon, Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useDisclosure, useToast, VStack } from '@chakra-ui/react'
import React, { useEffect, useMemo, useRef } from 'react'
import { BsWrench, BsX } from 'react-icons/bs'
import { putUpdateUserInfo } from '../../classes/User'
import { AL_RESET_PASSWORD, defaultSelectData, reload, useSelectedItemAlertContext } from '../../context/selectedItemAlertContext'
import { useUserContext } from '../../context/userContext'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'
import { SectionForm } from '../shared'
import UserInfoPreview from './UserInfoPreview'

const ModalUserResetPassword = ({ data }) => {
    const { onClose, isOpen, onOpen } = useDisclosure()
    const { setItemData } = useSelectedItemAlertContext()
    const { userData } = useUserContext()
    const toast = useToast()
    const newPassword = useMemo(() => process.env.REACT_APP_RESET_PASSWORD, [])
    const openModal = useRef()
    openModal.current = () => {
        if (data?.type === AL_RESET_PASSWORD && data?.id) onOpen()
    }

    useEffect(() => {
        openModal.current()
    }, [data])

    const onCloseHandle = () => {
        setItemData(defaultSelectData)
        onClose()
    }

    const resetPasswordHandle = async () => {
        const sendData = {
            password: newPassword
        }
        await putUpdateUserInfo(data?.id, sendData, userData.token)
            .then(res => {
                toast(toastVal({
                    title: "การรีเซ็ตรหัสผ่านสำเร็จ",
                    description: `บันทึกข้อมูล เรียบร้อยแล้ว`,
                }))
                setItemData((prev) => reload(prev))
                onCloseHandle()
            })
            .catch(error => {
                toast(toastVal({
                    title: "การรีเซ็ตรหัสผ่าน ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    return (
        <Modal isOpen={isOpen} onClose={onCloseHandle} size="4xl" colorScheme="blackAlpha" motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>แก้ไขรหัสผ่านของบัญชีผู้ใช้</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {
                        data?.id &&
                        <VStack w="full">
                            <UserInfoPreview uid={data?.id} short={true} />
                            <SectionForm header="แก้ไขรหัสผ่าน" divider={false}>
                                <Alert status="error">
                                    <AlertIcon />
                                    <Text>เฉพาะผู้ดูแลระบบ **รหัสผ่านใหม่จะเป็น <Text as="span" ml={2} fontWeight="bold">{newPassword}</Text></Text>
                                </Alert>
                                <Button leftIcon={<BsWrench />} colorScheme="red" onClick={resetPasswordHandle}>
                                    รีเซ็ตรหัสผ่าน
                                </Button>
                            </SectionForm>
                        </VStack>
                    }
                </ModalBody>
                <ModalFooter>
                    <Flex w="full" justify="center">
                        <Button leftIcon={<BsX />} colorScheme="blue" onClick={onCloseHandle}>
                            ปิดหน้าต่าง
                        </Button>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ModalUserResetPassword
